// When incidents end a shift: always, except in free play (#46), where it's
// the player's choice.

import { MAX_INCIDENTS } from '../config/constants.js';

export const incidentsEndShift = (s) => s.incidents >= MAX_INCIDENTS && (!s.free || s.free.incidentsEnd);
